import React, { createContext, useMemo, useEffect } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import PropTypes from 'prop-types';
import { getArchive } from '../api/subscription';
import { createLookupHash } from '../../../services/hash-service';

const ArchiveContext = createContext({});

const ArchiveContextProvider = ({ children }) => {
  const [archiveIds, setArchiveIds] = useAsyncSafeState([]);
  const [archives, setArchives] = useAsyncSafeState({});
  const [isLoading, setIsLoading] = useAsyncSafeState(true);
  const [hasError, setHasError] = useAsyncSafeState(false);

  useEffect(() => {
    getArchive()
      .then((response) => {
        const ids = response?.data.map((record) => record.monthlyStatId);
        setArchiveIds(ids);
        setArchives(createLookupHash(response?.data, 'monthlyStatId'));
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        setHasError(true);
      });
  }, [setHasError, setArchiveIds, setArchives, setIsLoading]);

  const value = useMemo(
    () => ({
      archiveIds,
      archives,
      isLoading,
      hasError,
    }),
    [archiveIds, archives, isLoading, hasError],
  );

  return <ArchiveContext.Provider value={value}>{children}</ArchiveContext.Provider>;
};

ArchiveContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export { ArchiveContext };

export default ArchiveContextProvider;
